module.exports = __webpack_public_path__ + "img/bg_function03_2_d.50a240ed.png";